export const MEMBERSHIPS = {
  CLASSIC: 'classic',
  CLASSIC_PAYG_ONLY: 'classic-payg-only',
  BASIC: 'basic'
}
